import {
  checkBlueIcon,
  checkGreenIcon,
  checkOrangeIcon,
} from "@/common/components/icons/svg-icons";

import Table from "@/common/components/Table";
import { MetricsCard } from "./metricCards/card1";
import { MetricsCard2 } from "./metricCards/card2";
import { StatsWrapper } from "./styles";
import { TableData } from "./data";

import { dashboardTableHeaders, dashboardTableKeys } from "./data";
import { ADMIN_DASHBOARD_STATS_URL } from "@/common/constants";
import useQuery from "@/hooks/useQuery";
import { formatToNaira } from "@/common/utils/general";

export default function AdminDashboard() {
  const { data } = useQuery(ADMIN_DASHBOARD_STATS_URL);
  return (
    <>
      <StatsWrapper>
        <div className="top-card-total">
          <MetricsCard
            icon={checkBlueIcon}
            value={formatToNaira(Number(data.transactions_processed)) || 0}
            title="TOTAL AMOUNT PROCESSED"
          />

          <MetricsCard
            icon={checkGreenIcon}
            value={data?.total_pending_approvals || 0}
            title="TOTAL PENDING APPROVAL"
          />

          <MetricsCard
            icon={checkOrangeIcon}
            value={data?.total_queried_companies || 0}
            title="TOTAL QUERIED COMPANY"
          />
        </div>

        <div className="bottom-card-total">
          <MetricsCard2
            description="Number of companies whose registration was approved"
            status="Approved"
            value={data?.total_approved || 0}
            title="TOTAL APPROVED"
            color="#00D522"
          />

          <MetricsCard2
            description="Number of companies whose registration was approved"
            status="Declined"
            value={data?.total_declined}
            title="TOTAL DECLINED"
            color="#FF4545"
          />
        </div>

        <div className="table flex-row">
          <Table
            tableData={TableData(data?.recent_companies)}
            tableHeaders={dashboardTableHeaders}
            tableKeys={dashboardTableKeys}
            full
            spaced
            rowLineColor="light"
            tableTitle="Total Companies"
            tableSubtitle={`${data?.recent_companies?.length} Total companies`}
          />
        </div>
      </StatsWrapper>
    </>
  );
}
